import { ColumnDef } from '@tanstack/react-table';
import Checkbox from '../../../../../../../../components/Common/UI/Checkbox';

export interface IUserLinkColRes {
  id: string;
  username: string;
  uniqueIdentifier: string;
  link: boolean;
}

export const userLinkCol: ColumnDef<IUserLinkColRes>[] = [
  {
    accessorKey: 'id',
    header: 'User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'username',
    header: 'Username',
    enableSorting: true,
  },
  {
    accessorKey: 'uniqueIdentifier',
    header: 'Unique Identifier',
    enableSorting: true,
  },
  {
    accessorKey: 'link',
    header: 'Link',
    enableSorting: true,
    cell: ({ row }) => <Checkbox id={row.getValue('id')} />,
  },
];

export const linkData: IUserLinkColRes[] = [
  {
    id: '12125465464',
    username: 'james123',
    uniqueIdentifier: '16569746546',
    link: false,
  },
  {
    id: '1654654446',
    username: 'joe1234',
    uniqueIdentifier: 'e4re4r5tr5',
    link: false,
  },
  {
    id: '9656856447',
    username: 'jane29043',
    uniqueIdentifier: 'uniqueid23',
    link: true,
  },
  {
    id: '33568977558',
    username: 'liu2939',
    uniqueIdentifier: '1010122933',
    link: false,
  },
  {
    id: '33568977552',
    username: 'liu2939',
    uniqueIdentifier: '1010122931',
    link: false,
  },
  {
    id: '33564977552',
    username: 'liy2939',
    uniqueIdentifier: '1050122931',
    link: false,
  },
];
